
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsColorDialog extends Serenity.EntityDialog<CsColorRow, any> {
        protected getFormKey() { return CsColorForm.formKey; }
        protected getIdProperty() { return CsColorRow.idProperty; }
        protected getLocalTextPrefix() { return CsColorRow.localTextPrefix; }
        protected getNameProperty() { return CsColorRow.nameProperty; }
        protected getService() { return CsColorService.baseUrl; }
        protected getDeletePermission() { return CsColorRow.deletePermission; }
        protected getInsertPermission() { return CsColorRow.insertPermission; }
        protected getUpdatePermission() { return CsColorRow.updatePermission; }

        protected form = new CsColorForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Colorid = Q.tryFirst(CsSkuRow.getLookup().items,x => x.ColorId == this.entity.ColorId);
            if(Colorid !=null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(CsPluRow.getLookup().items, x=> x.ColorId == this.entity.ColorId);            
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }
        
    }
}